import React from 'react';
import '../App.css';
import '../styles/Skills.css';
import useInView from '../hooks/useInView';

const skills = [
    { title: 'Soft', list: 'problem-solving, leadership, teamwork, adaptability' },
    { title: 'Tools', list: 'git, github' },
    { title: 'Frameworks', list: 'react, node.js' },
    { title: 'Programming', list: 'python, c++/c#, javascript, typescript, java' },
    { title: 'Languages', list: 'spanish (native), english (B2)' }
]

const Skills = () => {
    const [ref, visible] = useInView({ rootMargin: '-10px 0px -30% 0px', threshold: 0.08 });

    return (
        <div id='skills' ref={ref} className={`skills reveal ${visible ? 'visible' : ''}`}>
            <div className='subtitle'> <h2>Skills</h2> </div>

            <div>
                {skills.map((skill, idx) => (
                    <ul className='skill' key={idx}>
                        <li className='reveal-child' style={{ '--i': idx + 1 }}>{skill.title}: {skill.list}</li>
                    </ul>
                ))}
            </div>
        </div>
    );
}

export default Skills;